import React from "react"
import { TextField as MuiTextField } from "@material-ui/core"
import useStyles from "@/popups/components/TextField/styles"

export type TextFieldProps = {
	value: string
	onChange: (value: string) => void
	placeholder?: string
	label?: string
}

export const TextField: React.FC<TextFieldProps> = ({
	value,
	onChange,
	placeholder,
	label
}) => {
	const classes = useStyles()

	return (
		<MuiTextField
			fullWidth
			variant="outlined"
			value={value}
			onChange={(event) => onChange(event.target.value)}
			placeholder={placeholder}
			label={label}
			className={classes.root}
		/>
	)
}
